import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@env/environment';
import { AppDom } from '../dom/app-dom';
import { RouteHub } from '../dom/route-hub';
import { RouteAuth } from '@v1/modules/auth/dom/route-auth';

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.API_AUTH_DOMAIN,
  loginUrl: `${environment.API_AUTH_DOMAIN}/op/authorize`,
  logoutUrl: `${environment.API_AUTH_DOMAIN}/op/logout`,
  tokenEndpoint: `${environment.API_AUTH_DOMAIN}/op/token`,
  userinfoEndpoint: `${environment.API_AUTH_DOMAIN}/op/userinfo`,

  redirectUri: `${window.location.origin}/${environment.version}/${AppDom.auth}/${RouteAuth.callback}`,
  clientId: environment.clientId,
  responseType: 'code',
  scope: 'openid profile email offline_access',

  postLogoutRedirectUri: `${environment.WEB_AUTH_DOMAIN}/${environment.version}/${AppDom.auth}/${RouteHub.loginWeb}`,
  revocationEndpoint: `${environment.API_AUTH_DOMAIN}/op/revoke`,

  useSilentRefresh: false,
  timeoutFactor: 0.75,

  clockSkewInSec: 60,
  decreaseExpirationBySec: 0,

  requireHttps: environment.production,
  dummyClientSecret: '',
  showDebugInformation: !environment.production,

};
